export const STEP_1_AI_SEARCH = "postCar/AISearch";
export const STEP_2_AI_SEARCH_RESULT = "postCar/AISearchResult";
export const STEP_3_Manual_SEARCH = "postCar/ManualSearch";
export const STEP_4_PRICE = "postCar/Price";
export const STEP_5_UPLOAD = "postCar/UploadImage";
export const STEP_6_EXTRA_INFORMATION = "postCar/ExtraInformation";
export const STEP_7_Contact = "postCar/Contact";